module.exports = __webpack_public_path__ + "static/estrategies-9f6c24b3fa63162292f4a4b310c98369.png";